import "./StockSearch.module.scss"
import styles from "./StockSearch.module.scss"

import React, { MouseEvent, useState } from "react"

import { searchApi } from "@shared/apis"
import { useLayerPopupContext } from "@shared/contexts"

function StockSearch() {
  const { stock, close } = useLayerPopupContext()

  const [keyword, setKeyword] = useState<string>("")
  const [searchResults, setSearchResults] = useState<SearchResult | undefined>(
    undefined,
  )
  const [market, setMarket] = useState<Market>("ALL")

  const handleKeyboardInput = (e: React.FormEvent<HTMLInputElement>) => {
    setKeyword(e.currentTarget.value)
  }

  const handleSearch = () => {
    if (!keyword) return
    searchApi.query(keyword).then((response) => {
      setSearchResults(response)
    })
  }

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.keyCode === 13) {
      event.preventDefault()
      handleSearch()
    }
  }

  const handleMarket = (
    event: React.MouseEvent<HTMLElement>,
    market: Market,
  ) => {
    event.preventDefault()
    setMarket(market)
  }

  return (
    <React.Fragment>
      <article
        className="popup"
        style={{ width: "540px", margin: "-200px 0 0 -250px" }}
      >
        <div className="titB">
          <h1>종목검색</h1>
          <a
            href="#!"
            title="닫기"
            onClick={(e) => {
              e.preventDefault()
              close()
            }}
          >
            닫기
          </a>
        </div>
        <div className="txtB">
          <div className="searchW">
            <div className="inner">
              <p>종목검색</p>
              <input
                onChange={handleKeyboardInput}
                onKeyDown={handleKeyDown}
                value={keyword}
                type="text"
                placeholder="검색어를 입력하세요."
              />

              <input type="text" name="" placeholder="검색어를 입력하세요." />
            </div>
            <a
              href="#!"
              onClick={(e) => {
                e.preventDefault()
                handleSearch()
              }}
              className="btn"
              title="검색"
            >
              검색
            </a>
          </div>
          <dl className="ty02">
            <dt>구분</dt>
            <dd>
              <span className="radioB">
                <a
                  href="#!"
                  className={market === "ALL" ? "on" : ""}
                  onClick={(e) => {
                    handleMarket(e, "ALL")
                  }}
                >
                  <i>-</i>전체
                </a>
              </span>
            </dd>
            <dd>
              <span className="radioB">
                <a
                  href="#!"
                  className={market === "KOSPI" ? "on" : ""}
                  onClick={(e) => {
                    handleMarket(e, "KOSPI")
                  }}
                >
                  <i>-</i>KOSPI
                </a>
              </span>
            </dd>
            <dd>
              <span className="radioB">
                <a
                  href="#!"
                  className={market === "KOSDAQ" ? "on" : ""}
                  onClick={(e) => {
                    handleMarket(e, "KOSDAQ")
                  }}
                >
                  <i>-</i>KOSDAQ
                </a>
              </span>
            </dd>
          </dl>
          <div className="tableB">
            <table>
              <colgroup>
                <col width="110" />
                <col width="80" />
                <col width="*" />
              </colgroup>
              <thead>
                <tr>
                  <th>구분</th>
                  <th>코드</th>
                  <th>종목</th>
                </tr>
              </thead>
            </table>
            <div className="inner">
              <table>
                <colgroup>
                  <col width="110" />
                  <col width="80" />
                  <col width="*" />
                </colgroup>
                <tbody>
                  {searchResults?.suggestItems &&
                    searchResults.suggestItems.map((suggest: SuggestItem) => {
                      if (market === "ALL" || suggest.market === market) {
                        return (
                          <tr
                            className={styles.pointer}
                            key={suggest.code}
                            onClick={(e: MouseEvent) => {
                              e.preventDefault()
                              stock.handleStock({
                                name: suggest.koreanName,
                                shortCode: suggest.symbolCode,
                              })
                              close()
                            }}
                          >
                            <td>{suggest.market}</td>
                            <td>{suggest.symbolCode}</td>
                            <td>{suggest.koreanName}</td>
                          </tr>
                        )
                      }
                      return null
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </article>
    </React.Fragment>
  )
}

export default StockSearch

type Market = "ALL" | "KOSPI" | "KOSDAQ"

interface SearchResult {
  keyword: string
  suggestItems?: SuggestItem[]
  totalCount: number
  totalPages: number
  currentPage: number
  pageSize: number
}

interface SuggestItem {
  code: string
  symbolCode: string
  koreanName: string
  englishsName: string
  market: string
  securityType: string
  securityGroup: string
  displayCode: string
}
